import { render, staticRenderFns } from "./bookingDataTable.vue?vue&type=template&id=84bc41f4&scoped=true&"
import script from "./bookingDataTable.vue?vue&type=script&lang=js&"
export * from "./bookingDataTable.vue?vue&type=script&lang=js&"
import style0 from "./bookingDataTable.vue?vue&type=style&index=0&id=84bc41f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84bc41f4",
  null
  
)

export default component.exports